import { Controller } from 'stimulus'
import { getLogger } from '@blueberry/observability'
import CheckoutController from './checkout_controller'

const logger = getLogger('signup/form_address_controller')

export default class FormAddressController extends Controller {
  // Targets
  declare hasPhoneTarget: boolean
  declare phoneTarget: HTMLInputElement
  declare hasPhoneTarget: boolean
  declare address1Target: HTMLInputElement
  declare address2Target: HTMLInputElement
  declare cityTarget: HTMLInputElement
  declare stateTarget: HTMLInputElement
  declare zipTarget: HTMLInputElement

  static targets = ['phone', 'address1', 'address2', 'city', 'state', 'zip']

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  connect() {
    if (this.hasPhoneTarget) {
      this.phoneTarget.focus()
    } else {
      this.address1Target.focus()
    }
    this.setInitialValues()
    const step = this.checkoutOutlet.formTarget?.dataset.step
    const flow = this.checkoutOutlet.flowValue

    if (step === '3' && flow === 'd2c') {
      try {
        void this.checkoutOutlet.initializeStripe()
      } catch (error) {
        logger.error('Error initializing Stripe:', error)
      }
    }
  }

  setInitialValues() {
    if (!this.checkoutOutlet.signupData.address) return

    const { phone, address1, address2, city, state, zip } =
      this.checkoutOutlet.signupData.address

    if (this.hasPhoneTarget) {
      this.phoneTarget.value = phone || ''
    }
    this.address1Target.value = address1 || ''
    this.address2Target.value = address2 || ''
    this.cityTarget.value = city || ''
    this.stateTarget.value = state || ''
    this.zipTarget.value = zip || ''
  }
}
